import { render, staticRenderFns } from "./write.vue?vue&type=template&id=45df2a6f&scoped=true&"
import script from "./write.vue?vue&type=script&lang=js&"
export * from "./write.vue?vue&type=script&lang=js&"
import style0 from "./write.vue?vue&type=style&index=0&id=45df2a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df2a6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45df2a6f')) {
      api.createRecord('45df2a6f', component.options)
    } else {
      api.reload('45df2a6f', component.options)
    }
    module.hot.accept("./write.vue?vue&type=template&id=45df2a6f&scoped=true&", function () {
      api.rerender('45df2a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/setting/write.vue"
export default component.exports